"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformNetLabel = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformSchematicDrawing_1 = require("./TransformSchematicDrawing");
class TransformNetLabel extends TransformObject_1.TransformObject {
    constructor(parent, data, draw) {
        super(parent, {
            position: data.position,
            originalLabel: data.originalLabel,
            labelType: data.labelType,
            strategyMetadata: data.strategyMetadata,
            dimensions: data.dimensions,
            debugDrawings: [],
        }, undefined, new Set());
        if (draw) {
            this._sharedData.draw = new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, draw, this);
        }
        const debugLayer = this.context?.options?.combobulationDebugLayerId;
        if (debugLayer !== undefined) {
            this._sharedData.debugDrawings.push(new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [debugLayer],
                drawing: { type: 'junction', position: data.position, radiusOverride: 0.75 },
            }), new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [debugLayer],
                drawing: {
                    type: 'text',
                    value: `L:${data.originalLabel}`,
                    pos: [data.position[0] + 0.5, data.position[1]],
                    angle: 0,
                    justify: [-1, -1],
                    size: 1,
                    thickness: 1,
                },
            }));
        }
    }
    get creates() {
        return [...(this._sharedData.draw ? [this._sharedData.draw] : []), ...this._sharedData.debugDrawings];
    }
    compile() {
        const { position, originalLabel, labelType, strategyMetadata, dimensions } = this._sharedData;
        if (dimensions?.length) {
            const endpoints = dimensions.map((d) => ({ position, dimension: d }));
            return this.parent.netCombobulator.setLabel(endpoints, originalLabel, labelType, strategyMetadata);
        }
        return this.parent.netCombobulator.setLabel(position, originalLabel, labelType, strategyMetadata);
    }
}
exports.TransformNetLabel = TransformNetLabel;
//# sourceMappingURL=TransformNetLabel.js.map